import { graphql } from "@/gql";
import { ResultOf } from "@graphql-typed-document-node/core";

export type SupplierActiveLineStats = ResultOf<
  typeof supplierActiveLineStatsQuery
>["supplierActiveLineStats"];

export const supplierActiveLineStatsQuery = graphql(`
  query SupplierActiveLineStats($supplierId: ID!) {
    supplierActiveLineStats(supplierId: $supplierId) {
      available_count
      imoova_count
      transfercar_count
      coseats_count
      drivenow_count
    }
  }
`);
